import { CurrencyPipe, DatePipe } from '@angular/common';
import { Column, GridRow } from '@shared';
import { IPriceMismatch } from '@shared-data';

class PriceMismatch implements IPriceMismatch {
  kingRestaurantNo: string = '';
  kingRestaurantId: number = 0;
  restaurantId: number = 0;

  @Column({
    title: 'Group Key',
    field: 'groupKey',
    order: 1,
    width: 150,
    hidden: true,
  })
  groupKey: string = '';

  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 2,
    width: 90,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId: number = 0;

  @Column({
    title: 'Component Brink ID',
    field: 'componentParId',
    order: 2,
    width: 90,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  componentParId: number = 0;

  @Column({
    title: 'Product',
    field: 'itemName',
    order: 3,
    width: 150,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string = '';

  @Column({
    title: 'Component',
    field: 'componentName',
    order: 3,
    width: 100,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  componentName: string = '';

  @Column({
    title: 'Component Type',
    field: 'componentType',
    order: 3,
    width: 100,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  componentType: string = '';

  @Column({
    title: 'King Price',
    field: 'kingPrice',
    order: 4,
    width: 80,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  kingPrice: number = 0;

  @Column({
    title: 'King Delivery Price',
    field: 'kingDeliveryPrice',
    order: 6,
    width: 80,
    filterable: true,
    pipeToken: CurrencyPipe,
    filterType: 'numeric',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  kingDeliveryPrice: number = 0;

  @Column({
    title: 'Restaurant',
    field: 'restaurantNo',
    order: 3,
    width: 110,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  restaurantNo: string = '';

  @Column({
    title: 'Rest. Price',
    field: 'restaurantPrice',
    order: 5,
    width: 80,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  restaurantPrice: number = 0;

  @Column({
    title: 'Rest. Delivery Price',
    field: 'restaurantDeliveryPrice',
    order: 7,
    width: 80,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  restaurantDeliveryPrice: number = 0;

  constructor(pricemismatch?: Partial<PriceMismatch>) {
    if (!pricemismatch) {
      return;
    } else {
      Object.assign(this, pricemismatch);
    }
  }
}
export class GridRowPriceMismatch extends GridRow(PriceMismatch) {}
